// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-radio input[aria-hidden=\"true\"][data-v-49bc1006] {\n  display: none !important;\n}\n.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner[data-v-49bc1006] {\n  box-shadow: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
